<script>
import { mapActions } from 'pinia';
import { basketStore } from '../../../stores/basket';
import FormPicture from './../form/form-picture.vue';
import FormCheckbox from './../form/form-checkbox.vue';
import BasketItemSkuDisplay from './basket-item-sku-display.vue';
import { Tools } from '../../../utils/tools.js';

export default {
	components: {
		BasketItemSkuDisplay,
		FormCheckbox,
		FormPicture
	},
	props: {
		basketItem: {
			type: Object,
			default: () => ({})
		}
	},
	data() {
		return {
			isLoading: false
		};
	},
	methods: {
		...mapActions(basketStore, [
			'setBasketItemQuantity',
			'deleteBasketItem',
			'restoreBasketItem',
			'changeFavorites',
			'toggleSelectItem'
		]),

		async toggleSelect(value) {
			this.toggleSelectItem(this.basketItem, value);
		},
		
		async remove() {
			this.isLoading = true;
			await this.deleteBasketItem(this.basketItem);
			this.isLoading = false;
		},

		async restore() {
			this.isLoading = true;
			await this.restoreBasketItem(this.basketItem);
			this.isLoading = false;
		},

		async decreaseQuantity() {
			const updatedItem = {
				...this.basketItem,
				quantity: this.basketItem.quantity - this.basketItem.measureRatio
			};
			this.isLoading = true;
			await this.setBasketItemQuantity(updatedItem);
			this.isLoading = false;
		},

		async increaseQuantity() {
			const updatedItem = {
				...this.basketItem,
				quantity: this.basketItem.quantity + this.basketItem.measureRatio
			};
			this.isLoading = true;
			await this.setBasketItemQuantity(updatedItem);
			this.isLoading = false;
		},
		
		async changeQuantity({ target }) {
			const updatedItem = {
				...this.basketItem,
				quantity: target.value
			};
			this.isLoading = true;
			await this.setBasketItemQuantity(updatedItem);
			this.isLoading = false;
		},
		
		getPropValuesDescriptions(propCode, productPropValueCode) {
			return this.basketItem.combinationsPropertiesDescriptions[propCode]?.VALUES[productPropValueCode];
		},
		getPropName(propCode) {
			return this.basketItem.combinationsPropertiesDescriptions[propCode]?.NAME;
		},
		getPropValue(propCode, propValueCode) {
			return this.getPropValuesDescriptions(propCode, propValueCode)?.NAME;
		},
		getPriceFormated(){
			return this.$loc.get('BASKET_ITEM_PRICE', {
				'#PRICE#': Tools.formatPrice(this.basketItem.pricePerItem),
				'#MEASURE#': this.basketItem.measureName
			});
		}
	}
};
</script>

<template>
	<article class="card-cart-item card-product">
		<div class="card-cart-item__main">
			<div class="card-cart-item__image-wrapper">
				<FormCheckbox
					:id="'cart-item-checkbox-' + basketItem.basketId"
					v-bind:model-value="basketItem.isSelected"
					:class-list="{ 'card-cart-item__checkbox' : true }"
					@update:model-value="toggleSelect"
				/>
				<div class="card-cart-item__image">
					<FormPicture
						:source="basketItem.pictureSrc"
					/>
				</div>
			</div>
			<div class="card-cart-item__info">
				<div class="card-cart-item__name">
					<a :href="basketItem.url" >{{ basketItem.name }}</a>
				</div>
				<dl class="card-cart-item__props">
					<div 
						v-if="basketItem.article" 
						class="card-cart-item__prop"
					>
						<dt class="card-cart-item__prop-title">{{ $loc.get('ARTICLE_SHORT') }}:</dt>
						<dd class="card-cart-item__prop-value">{{ basketItem.article }}</dd>
					</div>
					
					<BasketItemSkuDisplay
						:basket-item="basketItem"
					/>
					
					<div class="card-cart-item__prop print-only">
						<dt class="card-cart-item__prop-title">{{ $loc.get('BASKET_ITEM_QUANTITY_LABEL') }}:</dt>
						<dd class="card-cart-item__prop-value">{{ basketItem.quantity }} шт.</dd>
					</div>
				</dl>
			</div>
		</div>
		<div class="card-cart-item__aside card-product__aside">
			<div class="card-cart-item__price-wrapper card-product__price-wrapper">
				<div class="card-product__price" v-html="getPriceFormated()"></div>
				<div class="card-product__price-date">{{ $loc.get('BASKET_ITEM_PRICE_DATE', {'#DATE#': basketItem.priceTimestamp}) }}</div>
			</div>
			<div class="card-cart-item__cart-wrapper card-product__cart-wrapper">
				<div class="counter card-product__cart-counter js-counter">
					<button
						v-if="basketItem.quantity <= basketItem.measureRatio"
						class="counter__button counter__button--remove button button--white" 
						type="button" 
						data-type="remove"
						@click="remove"
					>
						<i class="icon icon-trash"></i>
					</button>
					<button
						v-else
						class="counter__button counter__button--dec button button--white" 
						type="button" 
						data-type="dec"
						@click="decreaseQuantity"
					>
						<i class="icon icon-minus"></i>
					</button>
					<input 
						v-if="!basketItem.canBuyZero"
						class="counter__input" 
						type="number" 
						name="counter"
						:value="basketItem.quantity"
						min="1" 
						:max=basketItem.availableQuantity
						@change="changeQuantity"
					>
					<input
						v-else
						class="counter__input"
						type="number"
						name="counter"
						:value="basketItem.quantity"
						min="1"
						max=999999999
						@change="changeQuantity"
					>
					<button 
						class="counter__button counter__button--inc button button--white" 
						type="button" 
						data-type="inc"
						:disabled="!basketItem.canBuyZero && basketItem.quantity >= basketItem.availableQuantity"
						@click="increaseQuantity"
					>
						<i class="icon icon-plus"></i>
					</button>
				</div>
				<button 
					class="card-cart-item__fav-button card-product__fav-button button button--white"
					:class="{ 'card-product__fav-button--active': basketItem.isFavorite }"
					:aria-label="$loc.get('TO_FAVORITES')"
					@click="changeFavorites(basketItem);"
				>
					<i class="icon icon-heart"></i>
					<i class="icon icon-heart-filled"></i>
				</button>
			</div>
		</div>
	</article>
</template>

<style scoped>

</style>
